import { makeStyles } from '@mui/styles'

const landingPageStyle = makeStyles(() => ({
  base: {
    height: '100vh',
    width: '100vw',
  },
  content: {
    height: '70%',
    width: '50%',
    position: 'absolute',
    top: '15vh',
    left: '30px',
    borderRadius: '10px',
    boxShadow: '5px 5px 15px rgba(255, 255, 255, 0.2)',
    background: 'rgba(255, 255, 255, 0.2)',
    borderRight: '1.5px solid rgba(0, 0, 0, 1)',
    borderBottom: '1.5px solid rgba(0, 0, 0, 1)',
    backdropFilter: 'blur(10px)',
  },
}))

export default landingPageStyle
